import { Outlet } from 'react-router-dom';
import { Params, PublicPages } from '../utils/RouteEnums';
import React from 'react';

// Lazy-loaded components
const CompanyRegistrationRoute = React.lazy(() => import('./CompanyRegistrationRoute'));
const ContactRoute = React.lazy(() => import('./ContactRoute'));
const NewsPage = React.lazy(() => import('../components/newsSection/NewsPage'));
const NotFoundRoute = React.lazy(() => import('./NotFoundRoute'));

export const publicRoutes = [
    {
        getComponent: () => <CompanyRegistrationRoute />,
        path: PublicPages.COMPANY_REGISTRATION,
    },
    {
        getComponent: () => <ContactRoute />,
        path: PublicPages.CONTACT,
    },
    {
        getComponent: () => <Outlet />,
        path: PublicPages.NEWS,
        routes: [
            {
                getComponent: () => <NotFoundRoute />,
                path: '',
            },
            {
                getComponent: () => <NewsPage />,
                path: `:${Params.NEWSID}`,
            },
        ],
    },
];
